import { render, staticRenderFns } from "./EditFooter.vue?vue&type=template&id=2f4f09d9&scoped=true&"
import script from "./EditFooter.vue?vue&type=script&lang=js&"
export * from "./EditFooter.vue?vue&type=script&lang=js&"
import style0 from "./EditFooter.vue?vue&type=style&index=0&id=2f4f09d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4f09d9",
  null
  
)

export default component.exports